export default __webpack_public_path__ + "static/media/rocket.c3673f5c.svg";